











































import {
  defineComponent,
  useContext,
  useStatic,
  computed,
} from '@nuxtjs/composition-api'

export default defineComponent({
  setup() {
    const { route, $content } = useContext()

    const fileRoute = route.value.params.pathMatch
      .split('/')
      .filter((v) => v !== '')

    const fileData = useStatic(
      async () => await $content('downloads').fetch<any>(),
      undefined,
      'downloads',
    )

    const data = computed(() => {
      if (fileData.value === null) {
        return { files: [], folders: [] }
      } else if (route.value.params.pathMatch.length < 2) {
        return fileData.value
      } else {
        let pointer = fileData.value

        for (let i = 0; i < fileRoute.length; i++) {
          pointer = pointer?.folders?.[fileRoute[i]]

          if (!pointer) {
            return { files: [], folders: [] }
          }
        }

        return pointer
      }
    })

    function toBreadcrumb(key = '', depth = 0) {
      const item = {
        text: key,
        href: '/downloads/',
      }
      let curr = fileData.value

      // add title to subpath
      for (let i = 0; i < depth; i++) {
        curr = curr?.folders?.[fileRoute[i]]
      }
      item.text = curr?.title

      // add link to subpath
      if (fileRoute.length > depth) {
        item.href += fileRoute.slice(0, -fileRoute.length + depth).join('/')
      } else if (fileRoute.length === depth) {
        item.href += fileRoute.join('/')
      } else {
        item.href = undefined as unknown as string
      }

      return item
    }

    return {
      fileRoute,
      data,
      toBreadcrumb,
    }
  },
  head() {
    return {
      title: 'Downloads',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Download von Vorlagen, Dokumenten etc.',
        },
        // Open Graph
        { hid: 'og:title', property: 'og:title', content: 'Downloads' },
        {
          hid: 'og:description',
          property: 'og:description',
          content: 'Download von Vorlagen, Dokumenten etc.',
        },
        // Twitter Card
        { hid: 'twitter:title', name: 'twitter:title', content: 'Downloads' },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: 'Download von Vorlagen, Dokumenten etc..',
        },
        ...(this.$route.params.pathMatch.split('/').filter((v) => v !== '')
          .length > 0
          ? [{ hid: 'seo:index', property: 'robots', content: 'noindex' }]
          : []),
      ],
    }
  },
})
